const sharedStyles = {
  breakpoints: ["320px", "360px", "600px", "800px", "1000px", "1200px"],
  borderRadius: 15,
  gray: "#6c757d",
  grayDark: "#343a40",
  green: "#28a745",
  indigo: "#6610f2",
  info: "#17a2b8",
  light: "#e8e9ea",
  orange: "#fd7e14",
  pink: "#e83e8c",
  purple: "#6f42c1",
  danger: "#dc3545",
  success: "#28a745",
  teal: "#20c997",
  warning: "#ffc107",
  white: "#fff",
  yellow: "#ffc107",
  primary: "#999999", // RenTech Pink
  secondary: "#808080", // RenTech Blue
  borderColor: "#ced4da",
  buttonColor: "#EEEEEE",
  altButtonColor: "#6D6E71",
  buttonTextWhite: "#FFF",
  activeStageColor: "#13cdfd",
  inactiveStageForeColor: "#000",
  activeStageForeColor: "#FFF",
  completedStageColor: "#EEEEEE",
  incompleteStageColor: "#EEEEEE",
  accentColor: "#ffdd00",
  backgroundOffset: "#EEEEEE",
  boxShadowColor: "rgba(0, 0, 0, 0.2)",
  callToActionColor: "#e12f6e", //Pink
  emailLogo: "/uploads/theme/Selux_Logo_Schwarz_sRGB.jpg", // White
};

export const seluxLight = {
  primary: "#999999",
  secondary: "#808080",
  headerColor: "#000000",
  borderRadius:	3,
  success: "#194d33",
  warning: "#fcc400",
  callToActionColor: "#666666",
  tertiary: "#cccccc",
  gray: "#cccccc",
  grayDark: "#343a40",
  boxShadowColor:	"#4d4d4d",
  textDark: "#000000",
  headerTextColor: "#ffffff",
  backgroundColor: "#ffffff",
  gridRowBackgroundColor: "#e5e5e5",	
  borderColor: "#333333",
  darkMode: 0,
  companyLogo: "/images/Selux_Logo_Schwarz_sRGB.jpg", //TrinityLogo
  companyLogoWhite: "/uploads/theme/Selux_Logo_White_K.png", //White
  gridLineHoverBackgroundColor: "#EEEEEE",
  gridLineHoverOpacity: 0.9,
  gridLineHoverColor: "#000",
  gridRowAlternateBackgroundColor: "#f5f5f5",
  callToActionShadow: "0 0 0 1px #e12f6e !important",
  backgroundOpposite: "#000", //black
  imageActionColorFilter:
    "invert(77%) sepia(67%) saturate(2280%) hue-rotate(349deg) brightness(105%) contrast(98%)",
  darkBackground: "#6D6E71",
  lightBackground: "#EEEEEE", //Light Grey
  darkerOffset: "#D3D3D3", //Grey
  currentHighlight: "#13cdfd", //Electric Blue
  currentHighlightShadow: "0 0 0 1px #13cdfd !important",
  darkerHighlight: "#4D4D4D", //dark dark grey
  textLight: "#FFF", //White
  textMedium: "#A9A9A9", //dark grey
  actionRequired: "#d33115", //Red
  loadingIcon: "/images/loadingRipple.gif",
  ...sharedStyles,
}	

export const darkModeTheme = {
  primary: "#000000",
  secondary: "#73d8ff",
  headerColor: "#000000",
  borderRadius: 3,
  success: "#68bc00",
  tertiary: "#cccccc",
  warning: "#fcc400",
  callToActionColor: "#333333",
  gray: "#ffffff",
  grayDark: "#999999",
  boxShadowColor: "#ffffff",
  textDark: "#b3b3b3",
  backgroundColor: "#4d4d4d",
  gridRowBackgroundColor: "#ffffff",
  borderColor: "#ffffff",
  headerTextColor: "#ffffff",
  darkMode: false,
  pid: "ebf0c01b-05c6-43e3-ba42-6627c333aa3d",
  id: "190a4248-6efd-4a73-8c1e-0c39645ccdcc",
  loadingIcon: "/images/loadingRippleDark.gif",
  logo: "/uploads/theme/Selux_Logo_White_K.png", //TrinityLogoDarkMode
  logoDark: "/uploads/theme/Selux_Logo_White_K.png", // White  
  ...sharedStyles,
};				
